import React from "react";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    Container
} from "reactstrap";

import AuthService from "services/auth.service";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Deco from "security/deco";

class MobileNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            fullname: ""
        };
        this.sidebarToggle = React.createRef();
    }

    componentDidMount() {
        this.getFullNameUser();
    }

    componentDidUpdate(e) {
        if (
            window.innerWidth < 993 &&
            e.history.location.pathname !== e.location.pathname &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
            this.sidebarToggle.current.classList.toggle("toggled");
        }
    }

    toggle() {
        this.setState({ isOpen: !this.state.isOpen });
    }

    openSidebar() {
        document.documentElement.classList.toggle("nav-open");
        this.sidebarToggle.current.classList.toggle("toggled");
    }

    getFullNameUser() {
        const user = JSON.parse(Deco(localStorage.getItem('user')));
        this.setState({ fullname: user.fullname });
    }

    logout() {
        Swal.fire({
            title: 'Xác nhận',
            text: 'Bạn có chắc chắn muốn đăng xuất?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Đăng xuất',
            cancelButtonText: 'Hủy',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                AuthService.logout();
            }
        });
    }

    getMonthOptions() {
        const options = [];
        const now = new Date();
        for (let i = 0; i < 12; i++) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
            const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
            const label = `Tháng ${d.getMonth() + 1}/${d.getFullYear()}`;
            options.push({ value, label });
        }
        return options;
    }

    render() {
        const { isOpen } = this.state;
        const { isDashboard, selectedMonth, onMonthChange } = this.props;
        return (
            <>
                {/* Dark overlay when menu is open */}
                {isOpen && (
                    <div
                        onClick={() => this.setState({ isOpen: false })}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0,0,0,0.4)",
                            zIndex: 1029,
                            transition: "opacity 0.3s ease"
                        }}
                    />
                )}
                <Navbar
                    color="light"
                    expand="lg"
                    className="navbar-absolute fixed-top d-lg-none"
                    style={{
                        boxShadow: "0 2px 5px 0 rgba(0,0,0,.1)",
                        backgroundColor: "#ffffff",
                        zIndex: 1030
                    }}
                >
                    <Container fluid>
                        {/* Sidebar toggle */}
                        <div className="navbar-toggle">
                            <button
                                type="button"
                                ref={this.sidebarToggle}
                                className="navbar-toggler"
                                onClick={() => this.openSidebar()}
                                style={{
                                    padding: "10px",
                                    borderRadius: "5px",
                                    transition: "all 0.3s ease"
                                }}
                            >
                                <span className="navbar-toggler-bar bar1" />
                                <span className="navbar-toggler-bar bar2" />
                                <span className="navbar-toggler-bar bar3" />
                            </button>
                        </div>

                        {/* Centered page title */}
                        <div
                            style={{
                                flex: 1,
                                textAlign: "center",
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                padding: "15px",
                                lineHeight: "24px"
                            }}
                        >
                            {this.props.title}
                        </div>

                        {/* Kebab menu toggler */}
                        <NavbarToggler
                            onClick={() => this.toggle()}
                            style={{
                                padding: "8px",
                                borderRadius: "5px"
                            }}
                        >
                            <span className="navbar-toggler-bar navbar-kebab" />
                            <span className="navbar-toggler-bar navbar-kebab" />
                            <span className="navbar-toggler-bar navbar-kebab" />
                        </NavbarToggler>

                        {/* Collapsible mobile menu */}
                        <Collapse
                            isOpen={isOpen}
                            navbar
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "0 0 12px 12px",
                                boxShadow: isOpen ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
                                margin: "0 -15px",
                                padding: "0 0"
                            }}
                        >
                            <Nav navbar style={{ padding: 0 }}>
                                {isDashboard && (
                                    <NavItem
                                        className="d-flex align-items-center"
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            padding: "12px 18px",
                                            margin: 0,
                                            borderBottom: "1px solid #eee",
                                            color: "#333"
                                        }}
                                    >
                                        <i className="fa fa-calendar mr-2" style={{ fontSize: "18px", color: "#51bcda" }} aria-hidden="true"></i>
                                        <select
                                            value={selectedMonth}
                                            onChange={(e) => onMonthChange(e.target.value)}
                                            style={{
                                                padding: "4px 30px 4px 10px",
                                                borderRadius: "15px",
                                                border: "1px solid #ddd",
                                                fontSize: "13px",
                                                color: "#333",
                                                backgroundColor: "#f9f9f9",
                                                cursor: "pointer",
                                                outline: "none",
                                                fontWeight: "500",
                                                flex: 1,
                                                WebkitAppearance: "none",
                                                MozAppearance: "none",
                                                appearance: "none",
                                                backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "right 10px center",
                                                backgroundSize: "14px"
                                            }}
                                        >
                                            {this.getMonthOptions().map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    </NavItem>
                                )}
                                <NavItem
                                    className="d-flex align-items-center"
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        padding: "12px 15px",
                                        margin: 0,
                                        color: "#333"
                                    }}
                                >
                                    <i className="fa fa-user-circle mr-2" style={{ fontSize: "18px", color: "#51cbce" }} aria-hidden="true"></i>
                                    {this.state.fullname}
                                </NavItem>
                                <hr style={{ margin: 0, borderColor: "#eee" }} />
                                <NavItem
                                    className="d-flex align-items-center"
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        padding: "12px 15px",
                                        margin: 0,
                                        color: "#ef8157",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => this.logout()}
                                >
                                    <i className="fa fa-power-off mr-2" style={{ fontSize: "18px", color: "#ef8157" }} aria-hidden="true"></i>
                                    Đăng xuất
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </Container>
                </Navbar>
            </>
        );
    }
}

export default MobileNavbar;
